import React from "react";
import { logErrorToCloud } from "../tools/cloudLogProxy";

export default class CloudErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_) {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Never block rendering; fire-and-forget.
    logErrorToCloud(error, {
      source: "error_boundary",
      componentStack: info?.componentStack,
    });
  }

  render() {
    if (this.state.hasError) {
      // Minimal fallback; keep style simple to match existing app conventions.
      return (
        <div style={{ padding: 24 }}>
          <h2>Something went wrong.</h2>
          <p>Please reload the page. If this keeps happening, contact support.</p>
          <button
            type="button"
            onClick={() => {
              window.location.reload();
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}


